import { type RouteObject } from 'react-router';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { LabelsDesktopOnlyGuard } from '../guards/labels-desktop-only.guard';
import { PermissionGuard } from '../guards/permission.guard';
import { PrepackagedLabelAddonGuard } from '../guards/prepackaged-label-addon.guard';
import { type LazyRouteConfig, lazyRouteNamed } from '../lazy-route';

const LABEL_PERMISSIONS = ['NUTRITIONAL_LABELS', 'RECIPES'] as const;

function guardedRoute(path: string, lazyConfig: LazyRouteConfig): RouteObject {
  return {
    path,
    element: <PermissionGuard permission={LABEL_PERMISSIONS} />,
    children: [
      {
        path: '',
        element: <PrepackagedLabelAddonGuard />,
        children: [
          {
            path: '',
            element: <MainLayout />,
            children: [
              {
                path: '',
                element: <LabelsDesktopOnlyGuard />,
                children: [{ index: true, ...lazyConfig }],
              },
            ],
          },
        ],
      },
    ],
  };
}

export const labelsRoutes: RouteObject[] = [
  guardedRoute(
    RoutesList.LABELS,
    lazyRouteNamed(() => import('../../pages/labels/labels-route-pages'), 'LabelsListRoutePage'),
  ),
  guardedRoute(
    RoutesList.LABEL_LOT,
    lazyRouteNamed(() => import('../../pages/labels/labels-route-pages'), 'LabelsLotRoutePage'),
  ),
  guardedRoute(
    RoutesList.LABEL_RECIPE_STEP,
    lazyRouteNamed(() => import('../../pages/labels/labels-route-pages'), 'LabelsRecipeRoutePage'),
  ),
  guardedRoute(
    RoutesList.LABEL_RECIPE,
    lazyRouteNamed(() => import('../../pages/labels/labels-route-pages'), 'LabelsRecipeRoutePage'),
  ),
];
